import { render, staticRenderFns } from "./ratingOfParticipants.vue?vue&type=template&id=694618fa&scoped=true&"
import script from "./ratingOfParticipants.vue?vue&type=script&lang=js&"
export * from "./ratingOfParticipants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "694618fa",
  null
  
)

export default component.exports